var _rect, _rect2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.88825,
    y: 3.15715,
    width: 15.5878,
    height: 22.3812,
    rx: 3.25,
    transform: "rotate(-8.25039 4.88825 3.15715)",
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500741,
    y: 8.7267,
    width: 15.5878,
    height: 22.3812,
    rx: 3.25,
    transform: "rotate(-15.4826 0.500741 8.7267)",
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.5868,
    y1: 10.6195,
    x2: 10.0441,
    y2: 11.346,
    stroke: "#91BDFA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7948,
    y1: 14.613,
    x2: 8.43355,
    y2: 16.0751,
    stroke: "#91BDFA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard3);
export default __webpack_public_path__ + "static/media/Dashboard3.f2befad7c0636ef7b527acb84eff5c20.svg";
export { ForwardRef as ReactComponent };